import { NavbarComponent } from './navbar.component';
export const navbarRoute = {
    path: '',
    component: NavbarComponent,
    outlet: 'navbar2'
};
